import { useApiFetch } from '~/server/request'
import type { FetchResponseType } from '~/server/request/types'

interface CarSeries {
  carBrandName: string
  carSeriesName: string
  id: string
}
export async function getAllCarSeriesApi() {
  return useApiFetch<FetchResponseType<CarSeries[]>>('/webportal/base/series/all', {
    method: 'GET',
  })
}
